import Vue from 'vue';
import Component from 'vue-class-component';
import template from './design.html';
import './design.scss';

@Component({
	template: template,
})
export default class Design extends Vue {}
